import React, { Component } from "react";
import { defaultStyles } from "../util/styles";
import {
  withStyles,
  Grid,
  Typography,
  CircularProgress,
  Box,
  Container,
  Button,
} from "@material-ui/core";
import PropTypes from "prop-types";

const styles = (theme) => ({
  ...defaultStyles(theme),
  root: {
    position: "absolute",
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  title: {
    color: theme.palette.secondary.main,
    fontWeight: "light",
    textAlign: "center",
  },
  description: {
    color: "black",
    fontWeight: "light",
    textAlign: "center",
  },
});

class MessageOverlay extends Component {
  getContent = () => {
    const { classes, title, message, loading, messageText } = this.props;

    return (
      <Grid container justify="center" spacing={3} style={{ maxWidth: 500 }}>
        {loading ? (
          <Grid item>
            <Box pb={1}>
              <CircularProgress />
            </Box>
          </Grid>
        ) : (
          <Grid item xs={12}>
            <Typography variant="h4" className={classes.title}>
              {title}
            </Typography>
          </Grid>
        )}
        <Grid item xs={12}>
          <Typography className={classes.description}>{message}</Typography>
        </Grid>

        {messageText && (
          <Grid item xs={12} style={{ textAlign: "center" }}>
            <Button
              color="primary"
              variant="contained"
              key="button"
              disableElevation
              className={classes.w100}
              onClick={this.props.reset}
            >
              {messageText}
            </Button>
          </Grid>
        )}

        {this.props.additionalButtonsTitle && (
          <Grid item xs={12}>
            <Box pt={2}>
              <Typography className={classes.description}>
                {this.props.additionalButtonsTitle}
              </Typography>
            </Box>
          </Grid>
        )}

        {this.props.additionalButtons &&
          this.props.additionalButtons.map((button, index) => {
            return (
              <Grid item xs={12} key={index}>
                {button}
              </Grid>
            );
          })}
      </Grid>
    );
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Grid
          container
          className={classes.h100}
          alignItems="center"
          justify="center"
        >
          <Grid item>
            <Container>{this.getContent()}</Container>
          </Grid>
        </Grid>
      </div>
    );
  }
}

MessageOverlay.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  loading: PropTypes.bool,
  messageText: PropTypes.string,
  reset: PropTypes.func,
  additionalButtonsTitle: PropTypes.string,
  additionalButtons: PropTypes.array,
};

export default withStyles(styles)(MessageOverlay);
